<div class="footer-container">
  <div class="d-flex flex-row align-items-center footer-text">
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer-footer/pdf-viewer-footer.component.html